<template>
  <div>
    <div class="maintitle">{{ $route.meta.title }}</div>
    <el-divider></el-divider>
    <el-table :data="list" border>
      <el-table-column prop="department" label="部门"></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column :formatter="formatExcellent" label="优秀类型"></el-table-column>
      <el-table-column prop="score" label="得分"></el-table-column>
      <el-table-column label="操作">
        <template v-slot="scope">
          <el-button @click="getExcellentInfo(scope)" type="text">评分</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog v-if="excellentDiv" :visible.sync="excellentDiv" :show-close="false" :title="title" :close-on-click-modal="false"
               width="90%">
      <el-form class="text-left">
        <el-form-item label="优秀类型">
          <el-select v-model="crntScope.row.type" disabled>
            <el-option v-for="(item,index) in excellentTypeList" :key="index" :label="item.title"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table :data="excellentInfo" border :tree-props="{ children: 'children' }" row-key="id" default-expand-all>
        <el-table-column prop="title" label="考核内容"></el-table-column>
        <el-table-column label="理由">
          <template v-slot="scope">
            <span style="white-space: pre-wrap">{{ scope.row.beizhu }}</span>
          </template>
        </el-table-column>
        <el-table-column label="分值" prop="score" width="100"></el-table-column>
        <el-table-column label="评分" width="200">
          <template v-slot="scope">
            <el-input v-model="scope.row.point" v-if="scope.row.score !==''">
              <template slot="append">分</template>
            </el-input>
          </template>
        </el-table-column>
      </el-table>
      <div>合计：{{totalScore}}分</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
        <el-button type="primary" @click="submitReview">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      excellentTypeList:[],
      crntScope:'',
      excellentInfo:[],
      excellentDiv:false,
      title:''
    }
  },
  computed: {
    totalScore(){
      return this.getSummary(this.excellentInfo)

    }
  },
  methods: {
    getSummary(list){
      let total = 0;
      for(let item of list){
        if(item.children && item.children.length > 0){
          total += this.getSummary(item.children);
        }
        if(!isNaN(item.point)){
          total += Number(item.point);
        }
      }
      return total;
    },
    getList() {
      this.$axios({
        url: this.HOST + '/kaohe/pingshen/list',
        method: 'post',
      }).then((res) => {
        if (res.data.status === 1) {
          this.list = res.data.list;
        }
      })
    },
    formatExcellent(row){
      const res = this.excellentTypeList.filter(item => {
        return item.id === row.type;
      })
      return res.length>0?res[0].title:'';
    },
    getExcellentInfo(scope){
      this.crntScope = scope;
      this.$axios({
        url: this.HOST + '/kaohe/pingshen/getExcellent',
        method: 'post',
        data:{
          id:scope.row.id
        }
      }).then((res) => {
        if (res.data.status === 1) {
          this.excellentInfo = res.data.list;
          this.title = scope.row.name
          this.excellentDiv = true;
        }
      })
    },
    closeDialog(){
      this.excellentDiv = false;
    },
    submitReview(){
      this.$axios({
        url: this.HOST + '/kaohe/pingshen/saveExcellent',
        method: 'post',
        data: {info:this.excellentInfo,eid:this.crntScope.row.id},
      }).then(res => {
        if (res.data.status === 1) {
          this.$message({
            type: 'info',
            message: res.data.info
          })
          this.getList();
          this.excellentDiv = false;
        }
      })
    },
  },
  mounted() {
    this.$axios({
      url: this.HOST + '/kaohe/index/getCommonInfo',
      method: 'post',
      data: {
        info: ['excellentType'],
      }
    }).then((res) => {
      if (res.data.status === 1) {
        this.excellentTypeList = res.data.excellentType;
      }
    })
    this.getList()
  }
}
</script>